import React from "react";
import "../styles/DiscountModal.css";

const DiscountModal = ({
  show,
  onClose,
  onApplyDiscount,
  onProcessDiscounts,
  onSelectAndProcess,
  applicableDiscounts,
}) => {
  const handleSelectDiscount = (promo) => {
    if (onSelectAndProcess) {
      onSelectAndProcess(promo);
      return;
    }
    // Fallback: flujo original (aplicar + procesar manual)
    onApplyDiscount(promo);
    onClose();
  };

  if (!show) return null;

  return (
    <div className="dm-overlay" onClick={onClose}>
      <div className="dm-panel" onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="dm-header">
          <div className="dm-header-icon">
            <i className="bi bi-tag-fill" />
          </div>
          <div>
            <h3 className="dm-title">Aplicar Descuento</h3>
            <p className="dm-subtitle">Toca el descuento para aplicarlo</p>
          </div>
          <button className="dm-close" onClick={onClose} aria-label="Cerrar">
            <i className="bi bi-x-lg" />
          </button>
        </div>

        {/* Lista */}
        <div className="dm-body">
          {applicableDiscounts.length > 0 ? (
            <div className="dm-grid">
              {applicableDiscounts.map((promo) => (
                <button
                  key={promo.id}
                  className="dm-card"
                  onClick={() => handleSelectDiscount(promo)}
                >
                  <span className="dm-card-pct">{promo.price}%</span>
                  <span className="dm-card-name">{promo.name || "Descuento"}</span>
                  {promo.description && (
                    <span className="dm-card-desc">{promo.description}</span>
                  )}
                  <span className="dm-card-arrow">
                    <i className="bi bi-arrow-right-circle-fill" />
                  </span>
                </button>
              ))}
            </div>
          ) : (
            <div className="dm-empty">
              <i className="bi bi-slash-circle" />
              <p>Sin descuentos disponibles para este producto</p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="dm-footer">
          <button className="dm-btn-cancel" onClick={onClose}>
            <i className="bi bi-x" /> Cancelar
          </button>
        </div>

      </div>
    </div>
  );
};

export default DiscountModal;
